import PropTypes from 'prop-types';
import styles from '../clients/components/CountsPopup.module.scss';
import { getText } from '../../i18n';

const ImportReviewPopup = ({ x, y, onClose, reviewedBy, reviewedAt }) => {
    const modalStyle = {
        top: y,
        left: x,
        width: '200px',
        position: 'absolute',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        zIndex: 1000,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '20px 20px 15px',
    };

    return (
        <div style={modalStyle} className={styles.popupModal}>
            <button onClick={onClose} className={styles.closeButton}>
                <i className="bi bi-x"></i>
            </button>
            <div>
                <span style={{ color: 'var(--iNGAGED-Neutral-Color3)', padding: '0px', margin: '0px' }}><small>{getText('msg_7cd6a31f67cf')}</small></span><br />
                <span><small>{reviewedBy}</small></span><br />
                <span style={{ color: 'var(--iNGAGED-Neutral-Color3)', padding: '0px', margin: '0px' }}><small>{reviewedAt}</small></span>
            </div>
        </div>
    );
};

ImportReviewPopup.propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    reviewedBy: PropTypes.string.isRequired,
    reviewedAt: PropTypes.string.isRequired,
};

export default ImportReviewPopup;
